import { useMutation } from "react-query";
import { t } from "@/i18n-js/instance";
import { eventApi } from "@/react/api";
import { LOCATION_TYPES } from "@/react/components/Events/EditForm/helpers";
import { wasMinutesAgo } from "@/react/helpers/dateTimeHelpers";
import { useToast } from "@circle-react-uikit/ToastV2";

export const useLive = (event: any) => {
  const toastr = useToast();
  const { event_setting_attributes: eventData, policies } = event || {};

  const createLiveMutation = useMutation(
    () => eventApi.createLiveRoomForEvent({ event }),
    {
      onSuccess: () => {
        window.location.reload();
      },
      onError: () => {
        toastr.error(t("events.can_not_create_live_room_for_event"));
      },
    },
  );

  const {
    starts_at: startsAt,
    location_type: locationType,
    live_stream_slug: liveStreamSlug,
  } = eventData || {};

  const { can_manage_post: canManagePost, can_update_post: canUpdatePost } =
    policies || {};

  const willStartIn20Minutes = wasMinutesAgo(startsAt, 20);
  const isLiveEvent = [
    LOCATION_TYPES.LIVE_STREAM,
    LOCATION_TYPES.LIVE_ROOM,
  ].includes(locationType);
  const isCreated = !!liveStreamSlug;

  return {
    isLiveCreationError:
      willStartIn20Minutes &&
      isLiveEvent &&
      !isCreated &&
      (canManagePost || canUpdatePost),
    canCreateLive: canManagePost || canUpdatePost,
    createLiveMutation,
  };
};
